import { Box, TypographyProps } from "@mui/material"
import { FieldLabel } from "@shared/ui"

export interface TabProps {
    text: string
    onClick: () => void
    isActive?: boolean
    textProps?: TypographyProps
}

export function Tab(props: TabProps){
    const {
        text,
        onClick,
        isActive,
        textProps
    } = props
    return (
        <Box 
            onClick={onClick}
            sx={{
                borderBottom: `1px solid rgba(90, 103, 125, ${isActive ? ".25" : 0})`,
                '&:hover': {
                    cursor: 'pointer',
                    filter: 'contrast(200%)',
                    borderBottom: '1px solid rgba(90, 103, 125, .25)'
                }
            }}
        >
            <FieldLabel
                sx={{
                    fontWeight: isActive ? 500 : 400,
                    ...(textProps || {})
                }}
            >
                {text}
            </FieldLabel>
        </Box>
    )
}